import React from "react";
import ProjectsListing from "../ProjectListing/ProjectListing";

const MusicVideo = () => {
  return (
    <ProjectsListing categoryKey="musicVideoProjects" baseUrl="music-video" />
  );
};

export default MusicVideo;
